import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextSmall,
} from '../../components';

const EmbedInstructions = (props) => {
  const {
    dimensions,
  } = props;

  const width = dimensions.width < 640 ? dimensions.width - 40 : 600;

  return (
    <FormRow justifyContent='center'>
      <FormColumn width={width} padding={10}>
        <FormRow>
          <TextSmall fontWeight='bold'>
            {`${getDic("face-collector-instrucoes-1")}:`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-2")} https://face-recognition-app.sistemasinteegra.com.br/FaceScan?public=true&eventId={EVENTOID}&system={SISTEMA}`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-3")}`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-4")}`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-5")}:`}
          </TextSmall>
        </FormRow>
        <FormRow>
          <TextSmall>
            {`- 1) Para utilizar a câmera traseira adicione o parâmetro useBackCamera=true ao path.`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- Ao Dev: Após capturar a imagem, será emitido uma mensagem via window.top.postmessage com os dados em json {
              message: 'faceDetected',
              data: {
                guestId: detection._label,
                eventId: faceScanControl.eventId,
                system: faceScanControl.system,
              }
            }`}
          </TextSmall>
        </FormRow>
      </FormColumn>
    </FormRow>
  )
};

export default EmbedInstructions;
